<template>
  <div id="wrapper">
    <SidebarView :memacc="true" :memaccVisible="true" :addMemAcc="true" />
    <div class="d-flex flex-column" id="content-wrapper">
      <div id="content">
        <TopbarView />
        <div class="mx-3">
          <div class="row">
            <div class="col-12">
              <!-- begin loader -->
              <!-- <beat-loader-component
                        v-if="isLoading"
                        :isLoading="isLoading"
                        ></beat-loader-component> -->
              <!-- end loader -->
            </div>

            <div class="col-12">
              <div class="general-error d-flex justify-content-center pt-2 pb-2">
                <errors v-if="message">
                  {{ message }}
                </errors>
              </div>
              <div class="card card-shape home-box">
                <div class="card-header py-3 d-flex flex-row align-items-center">
                  <h6 class="m-0 fw-bold text-green">Create Product</h6>
                </div>
                <div class="card-body">
                  <b-form @submit.stop.prevent="saveData">
                    <account-form :account_options="account_options" :form='form'
                      :add_or_edit="add_or_edit"></account-form>
                    <hr />
                    <div class="text-center py-3">
                      <SaveButton :isSaving="isSaving" />
                      <button type="reset" class="btn akkurate-gray-btn text-white btn-size my-2 ms-3">
                        <font-awesome-icon class="me-2" :icon="['fas', 'rotate-right']" /> Reset</button>
                    </div>
                  </b-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>

    <!-- AI -->
		 <ChatBot />
		<!-- End AI -->
    <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
  </div>

</template>

<script>

import BeatLoaderComponent from "@/views/components/Loader/BeatLoaderComponent.vue";

import AccountForm from "./../forms/AccountForm.vue";
import SidebarView from '@/views/main/components/Sidebar.vue';
import TopbarView from '@/views/main/components/Topbar.vue';
import Footer from '@/views/main/components/Footer.vue'
import ApiService from "@/core/services/api.service";
import Multiselect from "vue-multiselect";
import SaveButton from "@/views/main/components/SaveButton.vue";
import ChatBot from "@/views/components/AI/ChatBot.vue";



export default {
  name: 'AccountCreate',
  components: {
    BeatLoaderComponent,
    AccountForm,
    SidebarView,
    TopbarView,
    Footer,
    Multiselect,
    SaveButton,
    ChatBot,
  },
  data() {
    return {
      ...this.initialState(),
      account_options: [],

    };
  },

  mounted() {
    this.getAccountTypes();
  },

  methods: {
    async getAccountTypes() {
      this.$Progress.start();
      await ApiService.get("/accounts/create/dropdown")
        .then((response) => {
          this.isLoadingSaving = false;
          this.$Progress.finish();
          this.account_options = response.data.account_types;
        })
        .catch((error) => {
          this.isSaving = false;
          this.$Progress.fail();
          if (error.response.data.errors) {
            this.form.errors = error.response.data.errors;
          }
        });
    },
    async saveData() {
      this.isSaving = true;
      this.$Progress.start();
      this.form.errors = [];
      await ApiService.post("/accounts/store", this.form)
        .then((response) => {
          this.isLoadingSaving = false;
          this.$Progress.finish();

          toast.fire({
            icon: "success",
            title: response.data.message,
          });
          this.isSaving = false;
          // this.form.reset();
          this.form = this.initialState().form;
        })
        .catch((error) => {
          this.isSaving = false;
          this.$Progress.fail();
          console.log(error.response.data.message);
          this.message = error.response.data.message;
          if (error.response) {
            this.form.errors = error.response.data.errors;
          }
        });


    },

    initialState() {
      return {
        form: {
          branch: {
            id: "",
            name: ""
          },
          account_type: "",
          account_option: [],
          balance: "",
          status: "Active",
          account_balance: 0,
          notes: "",
          member: "",
          member_option: [],
          status_option: ["Active", "Inactive", "Dormant", "Closed"],
          errors: [],
          auto_transfer: "0",
          maximum_withdrawal_frequency: "",
          commission: "0",
          commssion_amount: "",
          commission_frequency: "",
          apply_commission: "0",
          account_interest_start_date: "",
          account_commission_start_date: "",
          apply_interest: "0",
          auto_transfer_frequency: "",
          auto_transfer_amount: "",
          auto_transfer_account: "",
          auto_transfer_start_date: "",
          account_category: "INDIVIDUAL",
          is_withdrawable:"1",
        },
        isLoading: true,
        isSaving: false,
        add_or_edit: 'add',
        message: "",
      };
    },

  }


};
</script>

<!-- New step!
Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>